
// src/services/api.js
import { API_BASE_URL } from '../config';

export const getFilterOptions = async (endpoint) => {
  try {
    const response = await fetch(`https://your-api-id.execute-api.region.amazonaws.com/dev${endpoint}`);
    if (!response.ok) throw new Error('API call failed');
    return await response.json();
  } catch (error) {
    console.error('API Error:', error);
    return [];
  }
};

// Example canned queries
export const getBallotTypes = async (filters) => {
  const query = {
    filters,
    query: 'SELECT DISTINCT ballot_type FROM elections WHERE year = $1'
  };
  return getFilterOptions('/lambda-query', query);
};

export const getVoters = async (filters) => {
  const query = {
    filters,
    query: 'SELECT * FROM voters WHERE district = $1 AND party = $2'
  };
  return getFilterOptions('/lambda-query', query);
};
/**
 * Generic function to fetch data from the API
 * @param {string} endpoint - The API endpoint to call
 * @param {Object} params - Optional query parameters
 * @returns {Promise<Array>} - The fetched data
 */
export const fetchData = async (endpoint, params = {}) => {
  try {
    // Build query parameters
    const queryParams = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value) queryParams.append(key, value);
    });
    
    const queryString = queryParams.toString() ? `?${queryParams.toString()}` : '';
    const url = `${API_BASE_URL}${endpoint}${queryString}`;
    
    const response = await fetch(url);
    
    if (!response.ok) {
      throw new Error(`API error: ${response.status} ${response.statusText}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error('API Error:', error);
    throw error;
  }
};

/**
 * Get filter options from the API
 * @param {string} endpoint - The API endpoint to call
 * @param {Object} params - Optional query parameters
 * @returns {Promise<Array>} - The filter options
 */


/**
 * Get election data based on the selected filters
 * @param {string} endpoint - The API endpoint to call
 * @param {Object} filters - The selected filters
 * @returns {Promise<Array>} - The election data
 */
export const getElectionData = async (endpoint, filters = {}) => {
  try {
    return await fetchData(endpoint, filters);
  } catch (error) {
    console.error('Election data error:', error);
    throw error;
  }
};


